<template>
  <div v-if="clientLoaded">
    <navigation :links="links" :name="currentClient.name" @sign-out="signOut"></navigation>
    <main v-if="isDashboard" class="dashboard infos">
      <div class="container-fluid container-fluid--max">
        <notification></notification>
        <div class="dash-infos row">
          <div class="col-12 col-lg-8">
            <section class="dash-infos__card card">
              <div class="card-body">
                <div class="row h-100">
                  <section class="dash-infos__infos col-12 col-sm-5 text-secondary">
                    <h2 class="dash-infos__title heading-secondary position-relative">
                      Profil
                      <router-link :to="{ name: 'clientEditProfile' }" class="dash-infos__edit-btn" title="Modifier mes informations">
                        <i class="dash-infos__edit-icon fa fa-pencil-square" aria-hidden="true"></i>
                      </router-link>
                    </h2>
                    <div class="dash-infos__content text-center mt-3">
                      <div class="dash-infos__img-wrapper mx-auto mb-3 mb-sm-2">
                        <img class="dash-infos__img img-fluid" alt="Image du profil" :src="require(`@/assets/images/logo-${$appName}.jpg`)">
                      </div>
                      <h1 class="heading-primary">{{ currentClient.name }}</h1>
                      <div class="dash-infos__details smaller thin">
                        <p class="mb-0">{{ currentClient.email }}</p>
                        <p class="mb-0">{{ currentClient.phone }}</p>
                        <p class="mb-0">{{ currentClient.full_address }}</p>
                      </div>
                    </div>
                  </section>
                  <section class="dash-infos__prdts col-12 col-sm-7 text-primary mb-n3">
                    <hr class="d-sm-none my-4">
                    <h2 class="dash-infos__title heading-secondary mb-0">Mes produits</h2>
                    <moon-loader
                      :loading="loadingRequest"
                      :class="{'d-flex justify-content-center': loadingRequest}"
                      color="#dc3545"
                      size="30px">
                    </moon-loader>
                    <div v-if="!productRegistrations.length" class="text-center mt-lg-5">
                      <p class="text-muted my-4">Aucun produit n'a encore été enregistré.</p>
                      <router-link :to="{ name: 'productRegistrationForm', params: { id: 'new' } }" tag="a" class="btn" :class="'btn-' + $mainColor">
                        Ajouter un nouveau produit
                      </router-link>
                    </div>
                    <div class="dash-infos__prdt-card prdt-card row" v-for="pr in productRegistrations" :key="pr.id">
                      <div class="prdt-card__img-wrapper col">
                        <img class="prdt-card__img img-fluid" :alt="pr.product.name" :src="pr.product.image_path || require('@/assets/images/product-placeholder.png')">
                      </div>
                      <div class="prdt-card__details col-auto">
                        <h3 class="prdt-card__name">
                          {{ pr.product.name }}
                          <small v-if="pr.product.stove_type" class="bg-dark text-white px-2">{{ pr.product.stove_type }}</small>
                        </h3>
                        <div class="smaller thin">
                          <p class="mb-2">N° de série : <span class="prdt-card__value" v-if="pr.serial_number">{{ pr.serial_number }}</span></p>
                          <p class="mb-2">Date d’achat : <span class="prdt-card__value" v-if="pr.purchased_at">{{ pr.formatted_purchased_at }}</span></p>
                        </div>
                        <router-link
                          :to="{ name: 'productRegistrations', query: { id: pr.id }, hash: `#product_registration${pr.id}` }"
                          class="dash-infos__details-btn prdt-card__btn btn smaller"
                          :class="'btn-' + $mainColor">
                          Détails du produit
                        </router-link>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </section>
          </div>
          <div class="col-12 col-lg-4 mt-4 mt-lg-0">
            <section class="dash-infos__card card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-6 col-lg-12">
                    <div class="row h-100">
                      <div class="dash-infos__reviews col">
                        <h2 class="dash-infos__title heading-secondary mb-3">Mes avis</h2>
                        <div class="dash-infos__action action-display mb-2">
                          <i class="action-display__icon fa fa-star text-white p-2 round thinner" :class="'bg-' + $mainColor" aria-hidden="true"></i>
                          <span class="action-display__count dash-infos__action-count ml-2">{{ counts.reviews.count }}</span>
                        </div>
                        <p class="smaller mb-0">Moyenne de <span class="text-success">{{ counts.reviews.average }}/5</span></p>
                      </div>
                      <div class="dash-infos__assistance col">
                        <h2 class="dash-infos__title heading-secondary mb-3">Assistance</h2>
                        <div class="dash-infos__action action-display mb-2">
                          <i class="action-display__icon fa text-white py-2 px-1 round thinner" :class="'bg-' + $mainColor" aria-hidden="true">&#61523;&#61524;</i>
                          <span class="action-display__count dash-infos__action-count ml-2">{{ counts.requests.count }}</span>
                        </div>
                        <p class="smaller mb-0"><span class="text-success">{{ counts.requests.current_count }}</span> ce mois-ci</p>
                      </div>
                    </div>
                  </div>
                  <div class="dash-infos__shortcuts col-12 col-sm-6 col-lg-12">
                    <hr class="d-sm-none d-lg-block my-4">
                    <h2 class="dash-infos__title heading-secondary">Raccourcis</h2>
                    <router-link :to="{ name: 'supportRequestForm' }" class="prdt-card__btn btn btn-block mt-3" :class="'btn-outline-' + $mainColor">
                      Demande d'assistance
                    </router-link>
                    <!-- <router-link :to="{ name: 'clientContact' }" class="prdt-card__btn btn btn-block mt-3" :class="'btn-' + $mainColor">
                      Contacter {{ $appName | capitalize }}
                    </router-link> -->
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </main>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import Navigation from '@/components/layout/Navigation.vue'
import { mapState, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'Dashboard',
  components: {
    Navigation,
    MoonLoader
  },
  data () {
    return {
      links: [
        {
          title: 'Mes infos',
          pathname: 'clientDashboard',
          name: 'dashboard'
        },
        {
          title: 'Mes produits',
          pathname: 'productRegistrations',
          name: 'productRegistrations'
        },
        {
          title: 'Mes avis',
          pathname: 'reviews',
          name: 'reviews'
        },
        {
          title: "Demandes d'assistance",
          pathname: 'supportRequests',
          name: 'supportRequests'
        },
        {
          title: 'Contact',
          pathname: 'clientContact',
          name: 'contact'
        }
      ]
    }
  },
  computed: {
    ...mapState(['clientLoaded', 'currentClient', 'loadingRequest', 'counts']),
    ...mapGetters({ productRegistrations: `${store.$appName}/productRegistrations` }),
    isDashboard () {
      return this.$route.name === 'clientDashboard'
    }
  },
  methods: {
    signOut () {
      this.$store.dispatch('signOut', {
        type: 'client',
        router: this.$router
      })
    }
  }
}
</script>
